import React, { createContext, useContext, useEffect, useState } from 'react';
import { fetchApps, fetchSettings } from '../utils/adminApi';

const SiteContext = createContext(null);

export const SiteProvider = ({ children }) => {
  const [apps, setApps] = useState([]);
  const [settings, setSettings] = useState(null);
  const [loading, setLoading] = useState(true);

  const reload = async () => {
    try {
      const [a, s] = await Promise.all([fetchApps(), fetchSettings()]);
      setApps(a);
      setSettings(s);
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => { reload(); }, []);

  const topApps = apps.filter((a) => a.listType === 'top');
  const mainApps = apps.filter((a) => a.listType === 'main');
  const latestApps = apps.filter((a) => a.listType === 'latest');

  return (
    <SiteContext.Provider value={{ apps, topApps, mainApps, latestApps, settings, loading, reload }}>
      {children}
    </SiteContext.Provider>
  );
};

export const useSite = () => useContext(SiteContext);
